import script from "./NotarialActionMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionMain.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionMain.vue?vue&type=style&index=0&id=d69a5fd6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69a5fd6"]])

export default __exports__